import React, { useState, useRef, useEffect } from "react";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const DateRange = ({ dateRange, setDateRange, label = "Filter by Date" }) => {
  const [showPicker, setShowPicker] = useState(false);
  const pickerRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setShowPicker(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const formattedRange = `${dateRange[0].startDate.toLocaleDateString()} - ${dateRange[0].endDate.toLocaleDateString()}`;

  return (
    <div className="relative inline-block">
      <label className="block text-gray-600 font-semibold mb-1">{label}</label>
      <button
        onClick={() => setShowPicker(!showPicker)}
        className="bg-white border border-gray-300 rounded px-4 py-2 w-64 text-left shadow hover:border-blue-400"
      >
        {formattedRange}
      </button>

      {showPicker && (
        <div
          ref={pickerRef}
          className="absolute z-50 mt-2 shadow-lg rounded-lg overflow-hidden"
        >
          <DateRangePicker
            ranges={dateRange}
            onChange={(item) => setDateRange([item.selection])}
            months={1}
            direction="horizontal"
            showMonthAndYearPickers={true}
            rangeColors={["#3b82f6"]}
          />
        </div>
      )}
    </div>
  );
};

export default DateRange;